import { useEffect } from "react";

// Mount on routes that shouldn't show the themed scrollbar (own fixed/fullscreen
// canvases — audio, computer-vision, dsa, dino, sun).
export default function HideScrollbar() {
  useEffect(() => {
    document.body.classList.add("hide-scrollbar");
    return () => document.body.classList.remove("hide-scrollbar");
  }, []);

  return null;
}
